declare var dialogPolyfill: {
	registerDialog(dialog: HTMLDialogElement): void;
};
document.addEventListener("DOMContentLoaded", function (event) {
	document.querySelectorAll(".sa-highlight").forEach((highlight: SVGElement) => {
		highlight.querySelectorAll("[data-bubble]").forEach((hotspot: SVGGElement, index) => {
			let bubble = highlight.querySelector(`#${hotspot.dataset.bubble}`);
			bubble.classList.add("sa-highlight-bubble");
			hotspot.addEventListener("mouseover", function (event) {
				let active = highlight.querySelector(".sa--active");
				if (active) {
					active.classList.remove("sa--active");
				}
				bubble.classList.add("sa--active");
			});
			window.setTimeout(() => bubble.classList.add("sa--ready"), 200);
			if (index === 0) {
				bubble.classList.add("sa--active");
			}
		});
	});
	document.querySelectorAll<HTMLInputElement>("input[type=\"search\"]").forEach(searchbar => {
		let lists = searchbar.dataset.lists.split(/\s+/).map(list => document.querySelector<HTMLUListElement>(`ul[data-list="${list}"]`));
		let items = Array<HTMLLIElement>().concat(...lists.map(list => Array.from(list.querySelectorAll<HTMLLIElement>("li"))));
		searchbar.addEventListener("input", function (event) {
			let term = searchbar.value.trim().toUpperCase();
			items.forEach(item => item.classList.toggle("sa--hidden", !item.textContent.toUpperCase().includes(term)));
		});
	});
	let share = document.querySelector<HTMLDialogElement>("dialog.sa-share");
	dialogPolyfill.registerDialog(share);
	document.querySelectorAll<HTMLButtonElement>("button[data-share]").forEach(button => button.addEventListener("click", function (event) {
		share.showModal();
		document.body.classList.add("sa--locked");
	}));
	document.querySelector<HTMLButtonElement>("button.sa-share-close").addEventListener("click", function (event) {
		share.close();
		document.body.classList.remove("sa--locked");
	});
});
